// Kalenderdato (YYYY-MM-DD) i Europe/Oslo. Brukes der «i dag» og «forfalt»
// skal bety det samme for alle, uansett nettleserens tidssone.
const formatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Europe/Oslo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export const osloDateKey = (date: Date = new Date()): string =>
  formatter.format(date);

// Lokal tid for <input type="datetime-local"> (YYYY-MM-DDTHH:mm).
export const toDateTimeLocal = (date: Date = new Date()): string => {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

// Legg dager til en kalenderdato (YYYY-MM-DD) uten å gå via lokal tid.
export const addDaysKey = (key: string, days: number): string => {
  const [y, m, d] = key.split("-").map(Number);
  const date = new Date(Date.UTC(y, m - 1, d + days));
  return date.toISOString().slice(0, 10);
};

// Én datoform i hele Mimin (analysen v2): tabeller og lister viser
// d.m.åååå (24.10.2026), løpende tekst viser «24. okt.». Tar både
// kalenderdato (YYYY-MM-DD) og tidsstempel; tidsstempel tolkes i Oslo-tid.
const toOsloDate = (value: string): Date =>
  /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? new Date(`${value}T12:00:00`)
    : new Date(osloDateKey(new Date(value)) + "T12:00:00");

export const formatDateShort = (value: string | null | undefined): string => {
  if (!value) return "";
  const date = toOsloDate(value);
  if (Number.isNaN(date.getTime())) return value;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
};

export const formatDateText = (value: string | null | undefined): string => {
  if (!value) return "";
  const date = toOsloDate(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("nb-NO", { day: "numeric", month: "short" });
};
